import { render } from "./ConfirmAdminGrantDialog.vue?vue&type=template&id=f64403b2"
import script from "./ConfirmAdminGrantDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmAdminGrantDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__